module.exports = __webpack_public_path__ + "static/calendar-367edd6d896723d1264ff54688fbecb9.gif";